import { StyleSheet } from 'react-native'
import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  card: theme => ({
    flex: 1,
    padding: 16,
    marginTop: 16,
    borderRadius: 5,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  dropdown: (os, z) => ({
    zIndex: z,
    elevation: os === 'android' ? z : 0,
    marginHorizontal: '10px'
  }),
  helper: {
    paddingTop: 2,
    paddingLeft: 14
  },
  idStep: {
    paddingBottom: 64,
    paddingVertical: 32
  },
  button: { zIndex: -1 },
  header: {
    marginBottom: 16,
    fontWeight: 'bold',
    fontSize: Fonts.size.h4
  },
  description: {
    fontSize: 16,
    lineHeight: 19,
    letterSpacing: 0.2
  },
  divider: {
    zIndex: -1,
    marginVertical: 32,
    borderBottomWidth: 1,
    borderBottomColor: '#EBEBEB'
  },
  formHeader: {
    display: 'flex',
    paddingBottom: 16,
    alignItems: 'center',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#EBEBEB'
  },
  headerIcon: {
    marginRight: 22
  },
  uploadHolder: {
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#EBEBEB'
  },
  headerSubtitle: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  idUploadDescription: {
    fontSize: 14,
    lineHeight: 18,
    marginBottom: 20,
    letterSpacing: 0.1
  },
  formHolder: {
    paddingTop: 24,
    paddingBottom: 8
  },
  inlineFields: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  spaceRight: {
    marginRight: 8
  },
  flex: { flex: 1 },
  dropdownLabel: {
    fontSize: 20
  },
  spaceTop: {
    marginTop: 12
  },
  extraPadding: { paddingHorizontal: 6 },
  helperTxt: {
    paddingTop: 8,
    paddingLeft: 14
  },
  dropdownHeight: {
    height: 55,
    marginHorizontal: '10px'
  },
  errorTitle: { paddingBottom: 24 },
  inputText: theme => ({
    color: theme.colors.textColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6
  }),
  // Date Container
  inputsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  datesContainer: {
    flex: 1
  },
  inputLabel: (theme, error) => ({
    fontSize: 18,
    paddingTop: 16,
    paddingLeft: 12,
    color: error
      ? theme.colors.textInput.error.tintColor
      : theme.colors.textColor,
    fontFamily: Fonts.type.VFFont
  }),
  dateError: theme => ({
    marginTop: -8,
    paddingLeft: 12,
    paddingBottom: 6,
    color: theme.colors.textInput.error.tintColor
  }),
  container: {
    paddingHorizontal: '15%',
    paddingTop: 16,
    flexGrow: 1,
    gap: 16,
  },
  cardContentContainer: {
    paddingTop: 17,
    paddingHorizontal: 20,
    paddingBottom: 24,
  },
  inputWrapper: {
    gap: 16,
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  input: {
    flex: 1,
    overflow: 'hidden',

  },
  dropDownStyle: {
    borderWidth: 1,
    borderStyle: 'solid',
    flex: 1,
  },
  clientProfileHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    paddingBottom: 16,
  },
  clientItemWrapper: (isLast) => ({
    paddingTop: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

  }),
  uploadPhotoContainer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    borderRadius: '5px',
    gap: '5px',
  },
  uploadPhotoContainerChild: {
    flexDirection: 'row',
    flex: 1,
    width: '100%',
    alignItems: 'center',
  },
  uploadedImage: {
    flex: 1,
    flexDirection: 'row',
    marginLeft: '13.5px',
    gap: '17.5px',
    alignItems: 'center',
  },
  cancelUpload: {
    marginRight: '11px',
  },
  text: {
    textDecoration: 'underline',
  },
  uploadImageContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    borderRadius: '5px',
    padding: '20px',
    gap: '10.5px',
  },
  inputImage: {
    display: 'none',
  },
  uploadImageTitle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  fixAlignmnet: {
    alignItems: 'center',
  },
  bigContainerUploadImage: {
    flex: 1,
    padding: '10px',
    gap: '10.5px',
    flexGrow: 2.4,
    flexShrink: 2,
  },
  marginHorizontalSmall: {
    marginHorizontal: '10%'
  }
})

export default styles
